import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { paymentsApi, type BayiSummary } from '../../api/payments';
import { useAuth } from '../../auth/AuthContext';
import {
  Hero, StatTile, BarChart, Donut, RecentTable, DashSkeleton, compact,
} from '../../components/dashboard';
import { PaymentDetailModal } from '../../components/PaymentDetailModal';

/** Bayi ana sayfası — kendi tahsilat özeti (onaylı Mockup 2 tasarımı). */
export function BayiHome() {
  const { user } = useAuth();
  const [s, setS] = useState<BayiSummary | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [detail, setDetail] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    paymentsApi.summary().then(setS).catch(() => setError('Özet yüklenemedi'));
  }, []);

  if (error) return <div className="auth-error">{error}</div>;
  if (!s) return <DashSkeleton />;

  const weekTotal = s.weekly.reduce((a, w) => a + w.value, 0);

  return (
    <div className="dash">
      <div className="dash-head">
        <div>
          <h1>Hoş geldiniz, {user?.company_name || user?.full_name?.split(' ')[0] || 'Bayi'}</h1>
          <p>Tahsilat özetiniz. Banka ve taksit seçerek 3D Secure ile güvenle ödeme yapın.</p>
        </div>
        <button className="dash-cta" onClick={() => navigate('/odeme')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M12 5v14M5 12h14" /></svg>
          Ödeme Yap
        </button>
      </div>

      <Hero
        eyebrow="Toplam Ödemem"
        amount={s.totalPaid}
        delta={s.paidDeltaPct}
        weekly={s.weekly.map((w) => w.value)}
        minis={[
          { label: 'Onaylı Ödeme', value: String(s.approvedCount) },
          { label: 'Başarı Oranı', value: `%${s.successRate.toLocaleString('tr-TR')}` },
          { label: 'Bekleyen', value: String(s.pendingCount) },
        ]}
      />

      <div className="dash-stats">
        <StatTile tone="g" icon="check" value={String(s.approvedCount)} label="Onaylı Ödeme" />
        <StatTile tone="o" icon="clock" value={String(s.pendingCount)} label="Bekleyen İşlem" />
        <StatTile tone="r" icon="card" value={String(s.failedCount)} label="Başarısız Ödeme" />
      </div>

      <div className="dash-grid">
        <BarChart data={s.weekly} note={`Bu hafta ${compact(weekTotal)}`} />
        <Donut items={s.bankDistribution} total={s.approvedCount} />
      </div>

      <RecentTable rows={s.recent} showCustomer={false} onRow={(id) => setDetail(id)} />

      <PaymentDetailModal orderId={detail} onClose={() => setDetail(null)} />
    </div>
  );
}
